import "./ReadMore.scss";

import { Media } from "@Utilities/Media";
import enquire from "enquire.js";
import debounce from "debounce";

export class ReadMore
{
	public ActualHeightPrevious = 0;
	public Clamped = false;
	public ClampedHeight = 0;
	public Container: HTMLElement;
	public Height = 0;
	public Opened = false;
	public ReadMoreLink: HTMLElement;
	public Text: HTMLElement;

	constructor(desc: HTMLElement)
	{
		this.Container = desc;
		this.ConfigureReadMore();
	}

	public get ActualHeight(): number
	{
		let height = 0;

		if (typeof this.Text !== "undefined" && this.Text !== null)
		{
			height = this.Text.scrollHeight;
		}

		return height;
	};

	public get DisplayHeight(): number
	{
		let height = 0;

		if (typeof this.Text !== "undefined" && this.Text !== null)
		{
			const elStyles = window.getComputedStyle(this.Text);
			height = parseInt(elStyles.height);
		}

		return height;
	};

	public ConfigureReadMore = (): void =>
	{
		if (this.Container !== null)
		{
			this.Text = this.Container.querySelector(".readClamp__text");
			this.ReadMoreLink = this.Container.querySelector(".readClamp__link");

			const ResizeHandler = debounce(() =>
			{
				this.ClampUpdate();
			}, 200);

			enquire.register(Media.MediaMobile, {
				match: (): void =>
				{
					this.ClampUpdate();
					this.ReadMoreClose();
					window.addEventListener("resize", ResizeHandler);
				},
				unmatch: (): void =>
				{
					this.ClampRemove();
					this.ReadMoreClose();
					window.removeEventListener("resize", ResizeHandler);
				}
			});
		}
	};

	public ClampUpdate = (enable?: boolean): void =>
	{
		if (this.DisplayHeight < this.ActualHeight && !this.Clamped)
		{
			this.ClampApply();
		}
		else if (this.Opened && this.DisplayHeight === this.ClampedHeight)
		{
			this.ClampRemove();
			this.ReadMoreClose();
		}
		else if (!this.Opened && this.DisplayHeight === this.ActualHeight)
		{
			this.ClampRemove();
		}
	};

	public ClampApply = (): void =>
	{
		this.Container.classList.remove("readClamp--off");
		this.ReadMoreLink.addEventListener("click", this.ReadMoreToggle);
		this.Clamped = true;
		this.ActualHeightPrevious = this.ActualHeight;
		this.ClampedHeight = this.DisplayHeight;
	};

	public ClampRemove = (): void =>
	{
		this.Container.classList.add("readClamp--off");
		this.ReadMoreLink.removeEventListener("click", this.ReadMoreToggle);
		this.Clamped = false;
	};

	public ReadMoreOpen = (): void =>
	{
		this.Container.classList.add("readClamp--open");
		this.Opened = true;
	};

	public ReadMoreClose = (): void =>
	{
		this.Container.classList.remove("readClamp--open");
		this.Opened = false;
	};

	public ReadMoreToggle = (e: Event): void =>
	{
		if (typeof e !== "undefined" && e !== null)
		{
			e.preventDefault();
		}

		if (this.Opened)
		{
			this.ReadMoreClose();
		}
		else
		{
			this.ReadMoreOpen();
		}
	};
}